import type { SVGProps } from 'react';
const SvgFormatTextdirectionLToR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#format_textdirection_l_to_r_svg__a)">
      <path
        fill="currentColor"
        d="M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4Zm12 8-4-4v3H5v2h12v3l4-4Z"
      />
    </g>
    <defs>
      <clipPath id="format_textdirection_l_to_r_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFormatTextdirectionLToR;
